
import register from './register';
import bootstrap from './bootstrap';
import routes from './routes';
import controllers from './controllers';
import services from './services';
import config from './config';
import contentTypes from './content-types';

export default {
  register,
  bootstrap,
  config,
  contentTypes,
  routes,
  controllers,
  services,
};
